// Values come from .env (see .env.example) and are inlined into the client bundle at build time
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const API_SECRET = import.meta.env.VITE_API_SECRET;
export const GOOGLE_MAP_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const AG_GRID_LICENSE_KEY = import.meta.env.VITE_AG_GRID_LICENSE_KEY;
export const API_CALL_TIME = 3000; // 3 seconds (3000ms)


// Firebase
export const API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
export const MESSAGING_SENDER_ID = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
export const MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

export const USER = () => {
  try {
    const data = localStorage.getItem("user");
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
};

export const USER_ID = () => USER()?.user_id;